const oiFilterForm = document.getElementById('oi-filter-form');
let filterBatchLoader = null;

function update_url(resp) {
    if (window.history && "pushState" in window.history) {
        const url = resp.data.data.url;
        window.history.pushState(null, "", url);
        const canonical = document.querySelector('link[rel="canonical"]');
        if (canonical !== null) {
            canonical.href = url;
        }
    }
}
function groupBy(objectArray, property, value) {
    return objectArray.reduce(function (acc, obj) {
        const key = obj[property];
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(obj[value]);
        return acc;
    }, {});
}
function getFormData(filter_form) {
    let formData = new FormData(filter_form);
    let object = [];
    formData.forEach(function (value, key) {
        const o = {
            name: key,
            value: value,
        };
        object.push(o);
    });
    const pieces = groupBy(object, "name", "value");
    formData = new FormData();
    for (const piece in pieces) {
        if (pieces.hasOwnProperty(piece)) {
            formData.append(piece, pieces[piece].join("|"));
        }
    }
    return formData;
}
function oiFilterDisableForm(oi_filter_form) {
    if (oi_filter_form) {
        let i;
        // Disable all form inputs
        for (i = 0; i < oi_filter_form.elements.length; i++) {
            oi_filter_form.elements[i].setAttribute("disabled", "disabled");
        }
        // Disable all elements with class of "oi-disable-while-pending"
        const to_disable = document.getElementsByClassName(
            "oi-disable-while-pending"
        );
        for (i = 0; i < to_disable.length; i++) {
            to_disable[i].setAttribute("disabled", "disabled");
        }
        // Reduce the opacity of all elements with class of "model-filters"
        // ?? Can we just do this for all elements inside the form ??
        const model_filters = document.getElementsByClassName("model-filters");
        for (i = 0; i < model_filters.length; i++) {
            model_filters[i].style.opacity = "0.6";
        }
        // ?? What about an overlay and spinner ??
    }
}
function oiFilterEnableForm(oi_filter_form) {
    if (oi_filter_form) {
        setTimeout(function () {
            let i;
            // Remove the disabled attribute and value from inputs.
            for (i = 0; i < oi_filter_form.elements.length; i++) {
                oi_filter_form.elements[i].disabled = false;
                oi_filter_form.elements[i].removeAttribute("disabled");
            }
            // Remove disabled from all elements with class of "oi-disable-while-pending"
            const to_disable = document.getElementsByClassName(
                "oi-disable-while-pending"
            );
            for (i = 0; i < to_disable.length; i++) {
                to_disable[i].disabled = false;
                to_disable[i].removeAttribute("disabled");
            }
            // Reset the opacity of all elements with class of "model-filters"
            const model_filters =
                document.getElementsByClassName("model-filters");
            for (i = 0; i < model_filters.length; i++) {
                model_filters[i].style.opacity = "1";
            }
        }, 500);
    }
}
function oiFilterAjaxBeforesend(oi_filter_form, from_infinite) {
    if (from_infinite === undefined || from_infinite === false) {
        oiFilterDisableForm(oi_filter_form);
    }
}

function oiFilterGetResults(oi_filter_form, results) {
    batchLoader.forEach(b => b.abort());
    filterBatchLoader?.abort();
    beforeAjaxCompletion(oi_filter_form, results);
    const ftype = oi_filter_form.dataset.filterType;
    const url = `/xhr/filter/${ftype}/`;
    const formData = getFormData(oi_filter_form);
    oi.axios({
        method: "post",
        url: url,
        data: formData,
        headers: {
            "Content-Type": "application/json",
        },
        transformRequest: [
            function (data, headers) {
                // We're not really transforming the request, but this function runs
                // before the ajax posts.
                oiFilterAjaxBeforesend(oi_filter_form, false);
                // We let the data pass-through unchanged.
                return data;
            },
        ],
    })
        .then(function (resp) {
            afterAjaxCompletion(results);
            if (resp.data.data.result_list) {
                if (resp.data.options) {
                    const options = resp.data.options;
                    for (const id in options) {
                        document.getElementById(option).innerHTML =
                            options[option];
                    }
                }
                if (resp.data.paginator && resp.data.paginator !== "") {
                    const pageinput =
                        oi_filter_form.querySelector('input[name="page"]');
                    pageinput.value = resp.data.paginator.next;
                }
                // The sort select lives inside the results (linked via form=), so keep its value across re-renders
                const sortValue = oi_filter_form.elements["sort"]?.value;
                results.innerHTML = resp.data.data.result_list;
                const sortSelect = oi_filter_form.elements["sort"];
                if (sortSelect && sortValue) {
                    sortSelect.value = sortValue;
                }
                const oi_filter_amount = document.getElementById("oi-filter-amount");
                if (oi_filter_amount !== null) {
                    oi_filter_amount.innerHTML = resp.data.data.amount || 0
                }
                if (resp.data.result_list_lot) {
                    const results_lot = document.getElementById(
                        "oi-filter-results-lot"
                    );
                    results_lot.innerHTML = resp.data.result_list;
                }
                if (resp.data.result_list_land) {
                    const results_land = document.getElementById(
                        "oi-filter-results-land"
                    );
                    results_land.innerHTML = resp.data.result_list;
                }
                if (resp.data.map_items && resp.data.map_items !== "") {
                    const map_items =
                        document.querySelector(".oi-all-map-items");
                    map_items.innerHTML = resp.data.map_items;
                }
                update_url(resp);
                if (window.afterResultsSuccess !== undefined) {
                    window.afterResultsSuccess();
                }
                // ?? This appears to be formatted for maps pre-oilib ??
                oi.loaded.map['oi-map'].set_markers(ftype);
                oi.loaded.map['oi-map'].fit();
                const ftype_remaining = resp.data.data.ftype_remaining || [];
                filterBatchLoader = new oi.filter.LoadedBatch({
                    form: oi_filter_form.id || oi_filter_form.dataset.resultsTarget,
                    items: ftype_remaining,
                    filterType: ftype,
                    beforeLoad: () => onBeforeLoad(),
                    afterLoad: () => onAfterLoad(),
                    beforeBatchLoad: () => onBeforeBatchLoad(),
                    afterBatchLoad: (response) => onAfterBatchLoad(response, results),
                });
                if (!ftype_remaining.length) {
                    clearLoadState();
                }
            } else {
                clearLoadState();
            }
        })
        .catch(function (error) {
            afterAjaxCompletion(results);
            if (error.response) {
                if (error.response.status == 400) {
                    let msg = "";
                    const errors = error.response.data.errors;
                    for (let err in errors) {
                        let x = errors[err];
                        msg = `${x.code} - ${x.description}\n`;
                    }
                    oiFilterEnableForm(oi_filter_form);
                } else if (error.response.status == 302) {
                    // Redirecting
                    window.location.href = error.response.data.data.redirect;
                }
            } else if (error.request) {
                console.error(error.request);
            } else {
                console.error(error.message);
            }
        })
        .then(function () {
            const name_input = oi_filter_form.querySelector('input[name="m"]');
            if (name_input !== null) {
                name_input.value = "0";
            }
            oiFilterEnableForm(oi_filter_form);
        });
}
window.addEventListener("load", () => {
    const oi_filter_form = document.getElementById("oi-filter-form");
    if (oi_filter_form) {
        const oi_filter_clickables =
            oi_filter_form.querySelectorAll(".oi-filter-click");
        const oi_filter_changables =
            oi_filter_form.querySelectorAll(".oi-filter-change");
        oi_filter_clickables.forEach((elem) => {
            elem.addEventListener("click", (e) => {
                e.preventDefault();
                oiFilterGetResults(oi_filter_form, oi_filter_results);
            });
        });
        oi_filter_changables.forEach((elem) => {
            elem.addEventListener("change", (e) => {
                e.preventDefault();
                oiFilterGetResults(oi_filter_form, oi_filter_results);
            });
        });
        // Enter in the location search would otherwise post the form to the page
        oi_filter_form.addEventListener("submit", (e) => {
            e.preventDefault();
            oiFilterGetResults(oi_filter_form, document.getElementById("oi-filter-results"));
        });
        oi_filter_form.addEventListener("change", (e) => {
            if (e.target.closest(".filter-multiselect")) {
                updateMultiselectCounts();
            }
        });
        // Fields outside the form linked with form="oi-filter-form" (e.g. the sort select in the results)
        // are re-rendered on every response, so listen on the document instead of binding directly
        document.addEventListener("change", (e) => {
            if (e.target.matches('.oi-filter-change[form="oi-filter-form"]')) {
                e.preventDefault();
                oiFilterGetResults(oi_filter_form, oi_filter_results);
            }
        });
        const oi_filter_reset = oi_filter_form.querySelectorAll(".oi-filter-reset");
        const oi_filter_results = document.getElementById("oi-filter-results");
        if (oi_filter_reset !== null && oi_filter_results !== null) {
            oi_filter_reset.forEach((btn) => {
                btn.addEventListener("click", (e) => {
                    let i;
                    e.preventDefault();
                    const to_clear =
                        document.getElementsByClassName("oi-clear-on-reset");
                    if (to_clear) {
                        for (i = 0; i < to_clear.length; i++) {
                            if (to_clear[i].type == "select-one") {
                                to_clear[i].selectedIndex = 0;
                            }
                            if (to_clear[i].id == "boyl-input") {
                                to_clear[i].value = false;
                            }
                            if (to_clear[i].type == "checkbox") {
                                to_clear[i].checked = false;
                            }
                            if (to_clear[i].type == "search" || to_clear[i].type == "text") {
                                to_clear[i].value = "";
                            }
                            // Range slider's hidden value, which also resets the visible handles
                            if (to_clear[i].rangeSlider !== undefined) {
                                to_clear[i].value = "";
                                syncSliderToValue(to_clear[i]);
                            }
                        }
                        updateMultiselectCounts();
                    }
                    const buttons_to_reset =
                        document.getElementsByClassName("filter-button-on");
                    if (buttons_to_reset) {
                        for (i = 0; i < buttons_to_reset.length; i++) {
                            buttons_to_reset[i].classList.remove(
                                "filter-button-on"
                            );
                        }
                    }
                    oiFilterGetResults(oi_filter_form, oi_filter_results);
                });
            });
        }
    }
    let pathName = document.location.pathname;
    window.addEventListener("popstate", (e) => {
        if (pathName === e.target.location.pathname) {
            return false;
        }
        location.reload();
    });

});


// --- Batch Loading ---
// Customize loading indicators and per-batch behavior here.

function addLoadingMessage() {
    // Add a loading indicator while items are being fetched.
}

function removeLoadingMessage() {
    // Remove the loading indicator after items have been fetched.
}

function beforeAjaxCompletion(filterForm, resultsContainer) {
    // Fires before the filter XHR completes (use for pre-request UI state)
}

function afterAjaxCompletion(resultsContainer) {
    // Fires after the filter XHR completes (use to restore post-request UI state)
}

function onBeforeLoad() {
    // Fires before the first batch loads
    addLoadingMessage();
}

function dispatchItemsLoaded() {
    const itemsLoaded = new CustomEvent('oiItemsLoaded', { detail: { message: 'items loaded' } });
    document.dispatchEvent(itemsLoaded);
}

function clearLoadState() {
    removeLoadingMessage();
    dispatchItemsLoaded();
}

function onAfterLoad() {
    // Fires after every batch has loaded
    clearLoadState();
}

function onBeforeBatchLoad() {
    // Fires before each batch request
}

function onAfterBatchLoad(response, resultsContainer) {
    // Fires after each batch request
    resultsContainer?.insertAdjacentHTML('beforeend', response.data.data.result_list);
}

const batchLoader = [];

window.addEventListener('load', () => {
    document.querySelectorAll('.oi-filter-form').forEach((form) => {
        const items = JSON.parse(form.dataset.remainingItems || '[]');
        if (!items.length) {
            clearLoadState();
            return;
        }
        const resultsContainer = document.querySelector(form.dataset.resultsTarget || '#oi-filter-results');
        const loader = new oi.filter.LoadedBatch({
            items,
            form: form.id || form.dataset.resultsTarget,
            filterType: form.dataset.filterType || '',
            beforeLoad: () => onBeforeLoad(),
            afterLoad: () => onAfterLoad(),
            beforeBatchLoad: () => onBeforeBatchLoad(),
            afterBatchLoad: (response) => onAfterBatchLoad(response, resultsContainer),
        });
        batchLoader.push(loader);
    });
});


// --- Range sliders ---
// Each .js-range-slider text input (no name, never posted) drives a hidden "%min-max" input that is
// blank at full range so the server doesn't exclude records without a value.
function formatRangeValue(format, value, max) {
    const num = Number(value);
    if (format === "price") {
        if (num >= 1000000) return `$${(num / 1000000).toFixed(num % 1000000 ? 2 : 0).replace(/\.?0+$/, "")}M`;
        return `$${Math.round(num / 1000)}k`;
    }
    if (format === "number") return num.toLocaleString("en-US");
    return num === Number(max) ? `${num}+` : String(num);
}

function updateRangeLabel(input, from, to) {
    const label = input.closest(".range-slider-wrap")?.querySelector(".range-slider-value");
    if (!label) return;
    const min = Number(input.dataset.sliderMin);
    const max = Number(input.dataset.sliderMax);
    if (input.dataset.sliderDisable === "true" || (Number(from) === min && Number(to) === max)) {
        label.textContent = "Any";
        return;
    }
    const format = input.dataset.sliderFormat;
    label.textContent = `${formatRangeValue(format, from, max)} - ${formatRangeValue(format, to, max)}`;
}

function syncSliderToValue(rangeInput) {
    const slider = rangeInput.rangeSlider;
    const bounds = rangeInput.rangeSliderBounds;
    if (!slider || !bounds) return;
    if (rangeInput.value) {
        const [from, to] = rangeInput.value.slice(1).split("-");
        slider.update({ from: Number(from), to: Number(to) });
    } else {
        slider.update({ from: bounds.min, to: bounds.max });
    }
}

// With both handles on the same value, the top one can only move one way, so the slider looks stuck.
// Wait for the first mouse movement, then hand the drag to the handle that can move that direction.
function enableOverlapDrag(wrap) {
    // Bound to the wrap, not the slider element: the slider rebuilds its own markup on update()
    wrap.addEventListener(
        "mousedown",
        (down) => {
            const fromHandle = wrap.querySelector(".irs-handle.from");
            const toHandle = wrap.querySelector(".irs-handle.to");
            if (down.handedOver || !fromHandle || !toHandle || !down.target.closest(".irs-handle")) return;
            if (Math.abs(fromHandle.getBoundingClientRect().left - toHandle.getBoundingClientRect().left) > 1) return;

            down.stopImmediatePropagation();
            down.preventDefault();
            const release = () => {
                document.removeEventListener("mousemove", onMove, true);
                document.removeEventListener("mouseup", release, true);
            };
            const onMove = (move) => {
                if (Math.abs(move.clientX - down.clientX) < 3) return;
                release();
                const handover = new MouseEvent("mousedown", {
                    bubbles: true,
                    cancelable: true,
                    view: window,
                    button: 0,
                    clientX: down.clientX,
                    clientY: down.clientY,
                });
                handover.handedOver = true;
                (move.clientX < down.clientX ? fromHandle : toHandle).dispatchEvent(handover);
            };
            document.addEventListener("mousemove", onMove, true);
            document.addEventListener("mouseup", release, true);
        },
        true
    );
}

function initRangeSliders() {
    document.querySelectorAll(".js-range-slider").forEach((input) => {
        const wrap = input.closest(".range-slider-wrap");
        const hiddenInput = wrap?.querySelector('input[type="hidden"].oi-filter-change');
        if (!hiddenInput || typeof window.ionRangeSlider !== "function") return;

        const min = Number(input.dataset.sliderMin);
        const max = Number(input.dataset.sliderMax);
        const options = {
            skin: "round",
            type: "double",
            min: min,
            max: max,
            step: Number(input.dataset.sliderStep) || 1,
            values_separator: "-",
            input_values_separator: "-",
            hide_min_max: true,
            hide_from_to: true,
            force_edges: true,
            onStart: (data) => updateRangeLabel(input, data.from, data.to),
            onChange: (data) => updateRangeLabel(input, data.from, data.to),
            onUpdate: (data) => updateRangeLabel(input, data.from, data.to),
            onFinish: (data) => {
                const atFullRange = Number(data.from) === min && Number(data.to) === max;
                hiddenInput.value = atFullRange ? "" : `%${data.from}-${data.to}`;
                hiddenInput.dispatchEvent(new Event("change"));
            },
        };
        // Touch can't re-grab the handle you want once both overlap, so keep them one step apart there
        if (window.matchMedia("(pointer: coarse)").matches) {
            options.min_interval = options.step;
        }
        if (input.dataset.sliderDisable === "true") {
            options.disable = true;
            wrap.classList.add("is-disabled");
        }

        hiddenInput.rangeSlider = window.ionRangeSlider(input, options);
        hiddenInput.rangeSliderBounds = { min: min, max: max };
        enableOverlapDrag(wrap);
        syncSliderToValue(hiddenInput);
    });
}

// --- Location search ---
// Picking a datalist suggestion only fills the box (no "change" until blur/Enter), so submit it right away.
// Typing fires InputEvents with inputType "insertText"/"deleteContent..."; a pick is "insertReplacementText"
// (Chrome, keyboard or mouse) or a plain Event with no inputType (Firefox).
function initLocationSearch() {
    const input = document.getElementById("location-search");
    if (!input) return;

    let lastSubmitted = input.value;
    // Swallow the native change that follows blur/Enter once the same value has already been submitted
    input.addEventListener(
        "change",
        (e) => {
            if (e.isTrusted && input.value === lastSubmitted) {
                e.stopImmediatePropagation();
            }
            lastSubmitted = input.value;
        },
        true
    );
    input.addEventListener("input", (e) => {
        const picked = !(e instanceof InputEvent) || e.inputType === "insertReplacementText";
        if (!picked || input.value === lastSubmitted) return;
        input.dispatchEvent(new Event("change", { bubbles: true }));
    });
}

// --- Multiselect dropdowns ---
function updateMultiselectCounts() {
    document.querySelectorAll(".filter-multiselect").forEach((dropdown) => {
        const count = dropdown.querySelectorAll('input[type="checkbox"]:checked').length;
        const label = dropdown.querySelector(".filter-multiselect-count");
        if (label) label.textContent = count ? `${count} selected` : "Any";
    });
}

function initFilterControls() {
    initRangeSliders();
    initLocationSearch();
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initFilterControls);
} else {
    initFilterControls();
}
